import React, { FC, useContext } from 'react';

import { Button, Input, Toggle } from '@smartshell/ui-kit';
import { Controller } from 'react-hook-form';

import { LocalizationContext } from 'localization';

import { IRunFileFormProps } from './interfaces';
import s from './RunFileModal.module.scss';

const RunFileForm: FC<IRunFileFormProps> = ({
  control,
  watch,
  isDirty,
  isSubmitting,
}) => {
  const { t } = useContext(LocalizationContext);

  const isSaved = watch('saved');
  const path = watch('path');

  return (
    <>
      <div className={s.form__inputs}>
        <Controller
          render={({ field, fieldState: { error } }) => (
            <Input
              {...field}
              title={t('host.start_command.modal.form.path')}
              error={error?.message}
            />
          )}
          name="path"
          control={control}
          rules={{
            required: t('errors.required'),
            minLength: {
              value: 6,
              message: t('errors.minLength', 6),
            },
            maxLength: {
              value: 256,
              message: t('errors.maxLength', 256),
            },
          }}
        />
        {/*<Controller*/}
        {/*  render={({ field, fieldState: { error } }) => (*/}
        {/*    <Input*/}
        {/*      {...field}*/}
        {/*      title={t('host.start_command.modal.form.argument')}*/}
        {/*      error={error?.message}*/}
        {/*    />*/}
        {/*  )}*/}
        {/*  name="argumentsCommand"*/}
        {/*  control={control}*/}
        {/*/>*/}

        <Controller
          render={({ field }) => (
            <Toggle
              {...field}
              className={s.form__saved}
              label={t('host.start_command.modal.form.save_template')}
            />
          )}
          name="saved"
          control={control}
        />

        {isSaved && (
          <Controller
            render={({ field, fieldState: { error } }) => (
              <Input
                {...field}
                title={t('host.start_command.modal.form.template_name')}
                error={error?.message}
              />
            )}
            name="title"
            control={control}
            rules={{
              required: t('errors.required'),
              minLength: {
                value: 6,
                message: t('errors.minLength', 6),
              },
              maxLength: {
                value: 20,
                message: t('errors.maxLength', 20),
              },
            }}
          />
        )}
      </div>

      <Button
        type="submit"
        fullWidth
        className={s.form__submit}
        disabled={!path}
        isLoading={isSubmitting}
      >
        {isDirty && isSaved
          ? t('host.start_command.modal.form.saved')
          : t('host.execute.submit')}
      </Button>
    </>
  );
};

export default RunFileForm;
